import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const CommunicationPreferences = lazyWithRetry(() => import('./CommunicationPreferences'));

const CommunicationPreferencesRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="communication-preferences">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <CommunicationPreferences />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default CommunicationPreferencesRoutes;
